import React, {useEffect, useContext} from "react";
import { Link, useNavigate } from "react-router-dom";
import logo from "./../../../Public/img/logo-black.png";
import userlogo from "./../../../Public/img/avatar-14.jpg";
import { AuthContext } from "../../../context/AuthContext";


const Header = () =>{

    const navigate = useNavigate();
    const {user, setUser} = useContext(AuthContext);

    const dashboardurl = `${window.location.origin}/caller/dashboard`;

    useEffect(() =>{
        //verifyUserAPI(navigate);

    }, []);

    const handleLogout = () =>{

        //localStorage.removeItem('cpmstoken');
        sessionStorage.removeItem('cpmstoken');
        localStorage.removeItem('userinfo');
        setUser(null);

        navigate('/sign-in', { replace: true });
    }

    return (
        <div className="header">
            <div className="header-left active">
                <Link to={dashboardurl} className="logo logo-normal img-logo">
                    <img src={logo} alt="Logo" />
                    
                </Link>
                
            </div>

            <Link id="mobile_btn" className="mobile_btn" to="#sidebar">
                <span className="bar-icon">
                    <span></span>
                    <span></span>
                    <span></span>
                </span>
            </Link>

            <div className="header-user">
                <ul className="nav user-menu">
                    <li className="nav-item nav-search-inputs me-auto">
                        
                    </li>

                    <li>
                        
                    </li>

                    <li className="nav-item nav-list">
                        <ul className="nav">
                            
                        </ul>
                    </li>
                    
                    <li className="nav-item nav-item-email nav-item-box">
                        <div className="" style={{ cursor: "pointer" }} onClick={handleLogout}>
                            <svg  xmlns="http://www.w3.org/2000/svg"  width="34"  height="34"  viewBox="0 0 21 21"  fill="none"  stroke="currentColor"  strokeWidth="2"  strokeLinecap="round"  strokeLinejoin="round"  className="icon icon-tabler icons-tabler-outline icon-tabler-power">
                                <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                                <path d="M7 6a7.75 7.75 0 1 0 10 0" />
                                <path d="M12 4l0 8" />
                            </svg>
                        </div>
                    </li>

                    
                </ul>
            </div>

            
        </div>
    )

}

export default Header;